import register from '@kpsys/angularjs-register';
import KpSimilarDocumentsComponent from './kp-similar-documents.component';
import SimilarDocumentsDataService from '../../data-services/similar-documents.data-service';

/**
 * @ngdoc module
 * @name kp-similar-documents
 * @module portaro.components.kp-similar-documents
 *
 */

export default register('portaro.components.kp-similar-documents')
    .service(SimilarDocumentsDataService.serviceName, SimilarDocumentsDataService)
    .component(KpSimilarDocumentsComponent.componentName, KpSimilarDocumentsComponent)
    .name();
